import React from "react";
import './NotFoundExam.scss';
import NotFoundExamImage from "../../../assest/images/UnderConstruction-Illustration.svg";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";

export default class NotFoundExam extends React.PureComponent<{ title?: string }, {}> {

    render(): React.ReactNode {
        return (
            <div className="coming-Soon not-found-area">
                <NotFoundDataInDate config={{ height: "124", width: "230", subTitleClass: "" }} image={NotFoundExamImage} title={this.props.title ?? "درحال حاضر آزمونی تعریف نشده است"} />
            </div>
        )
    }
}